import {interpolate, pgettext} from 'topmeteo/utils/i18n';

const Label = pgettext('location forecast', 'reference %(value)s m');

const getLabel = value => interpolate(Label, {value});

const Reference = ({reference}) => (
    <span className="reference">
        {getLabel(reference)}
    </span>
);

export default Reference;
